module.exports = __webpack_public_path__ + "img/5.ffad80c6.png";